<template>
    <div class="form-row mb-2"
    :class="[data.width, data.class]">

        <transition name="slide-fade">
            <component
            v-if="visible" 
            :is="rowFile"
            :errors="readonly ? null : row.key"
            :readonly="readonly"
            :label="$trans(row.name)"
            :label-class="data['label-class']"
            v-model="answer" 
            :row="row" />
        </transition>

    </div>
</template>

<script>

    import {mapState, mapGetters} from 'vuex'

    export default {

        props: {
            row: {
                type: Object,
                default: () => {}
            },

            readonly: {
                type: Boolean,
                default: false
            }
        },

        computed: {

            ...mapGetters('form', [
                'isVisible'
            ]),

            visible() {
                return this.isVisible(this.row)
            },

            ...mapState({
                form: state => state.form.form,
                answers: state => state.form.answers,
                errors: state => state.app.errors,
                displayErrors: state => state.form.displayErrors,
                customFieldsValidations: state => state.form.customFieldsValidations
            }),

            data() {
                return this.row.data ? this.row.data : {}
            },

            answer: {
                get() { return _.get(this.answers, this.row.key) },
                set(value) { 
                    this.$store.dispatch('form/setAnswer', {
                        key: this.row.key,
                        value: value
                    }) 
                }
            },

            rowFile() {

                var type = 'Unknown'
                var custom = false
                var rows = require.context('@components/forms/rows', true);
                var key = this.form.theme ? this.form.theme : this.form.key

                rows.keys().forEach(file => {

                    file = _.kebabCase(file.replace('.vue', ''))

                    if(file.includes(this.row.type))
                    {
                        type = _.camelCase(this.row.type)
                        type = type[0].toUpperCase() + type.substring(1)
                    }
                })

                // Is there a custom row ?
                if(this.row.type == 'custom')
                {
                    var search = this.$options.filters.capitalize(
                        _.camelCase(this.row.data.custom)
                    )

                    try {
                        let file = require('@components/forms/rows/'+search);
                        type = search
                    } catch (e) {}

                    try {
                        let file = require('@components/forms/'+key+'/rows/'+search);
                        type = search
                    } catch (e) {}

                }
                

                // Is it exists in a custom context ?
                try {
                    let file = require('@components/forms/'+key+'/rows/'+type);
                    custom = true
                } catch (e) {}


                if(type) {
                    return () => custom 
                    ? import(`@components/forms/${key}/rows/${type}.vue`)
                    : import(`@components/forms/rows/${type}.vue`);
                }

            }

        },

        watch: {
            displayErrors: {

                handler(value) {
                    
                    if(!this.readonly && value)
                    {
                        var errors = _.get(
                            this.customFieldsValidations[this.row.key],
                            'errors',
                            {}
                        )

                        if(!_.isEmpty(errors)) {
                            this.$store.commit('app/pushErrors', errors)
                        }

                    }

                },
                deep: true
            }
        }

    }
</script>